import React, {Component, Fragment} from 'react';
import MediaSelectModal from '../Forms/MediaSelectModal';
import {mediaUrl} from '../../helpers/Helpers';
import {classNamesPrefixed} from '../../../helpers/CoreHelpers';
import Collapsible from 'react-collapsible';
import {collapsibleSettings} from '../../helpers/Helpers';
import BtnPrimary from "../UI/BtnPrimary";
import MediaItem from "../UI/MediaItem";
import {single} from "../../store/actions/media";
import {connect} from "react-redux";

class ImageField extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            image: {}
        };
        this.clear = this.clear.bind(this);
        this.edit = this.edit.bind(this);
    }

    componentDidMount() {
        const {value} = this.props.input;

        if (value) {
            if (value.mediaId) {
                this.props.single(value.mediaId);
            }
            this.setState({
                image: value
            });
        }
    }

    showModal(e) {
        e.preventDefault();

        this.setState({
            modal: true
        });
    }

    hideModal() {
        this.setState({
            modal: false
        });
    }

    save(image) {
        let fileData = {
            id: image.id,
            mediaId: image.id,
            mediaUrl: mediaUrl(image),
            fileName: image.fileName,
            ref: image.ref
        };

        this.props.input.onChange(fileData);
    }


    edit(e) {
        e.preventDefault();

        this.setState({
            modal: true
        });
    }

    clear(e) {
        e.preventDefault();

        const {input} = this.props;

        input.onChange(null);

        this.setState({
            image: {},
            modal: false
        });
    }

    insertImage(name, listOfMediaFiles) {
        if (listOfMediaFiles.length === 1) {
            this.save(listOfMediaFiles[0]);
            this.setState({image: listOfMediaFiles[0]});
        }

        this.hideModal();
    }

    render() {
        const {modal, image} = this.state;
        const {input, omitCollapsible, label, meta: {touched, error}, expanded, loadedMediaItem, message} = this.props;

        let mediaItem = image ? image : (input.value ? input.value : null);

        if (mediaItem && loadedMediaItem && loadedMediaItem.data.id === mediaItem.mediaId) {
            mediaItem = {
                ...mediaItem,
                ...loadedMediaItem.data
            }
        }


        const content = (
            <React.Fragment>
                {input.value === '' ? (
                    <div className={classNamesPrefixed({'ImageField-empty': true})}>
                        <p>
                            <i>
                                {message} {message && <br/>}
                                Choose a file from the media library or upload a new one.
                            </i>
                        </p>
                        <div className={classNamesPrefixed({'form-actions': true})}>
                            <BtnPrimary small onClick={this.showModal.bind(this)}>Select image</BtnPrimary>
                        </div>
                    </div>
                ) : (
                    <div className={classNamesPrefixed({'ImageField-selected': true})}>
                        <div className={classNamesPrefixed({'ImageField-image': true})}>
                            {mediaItem &&
                            <MediaItem
                                item={mediaItem}
                                key={mediaItem.id}
                                editEnabled={true}
                                onEdit={this.edit}
                                deleteEnabled={true}
                                onDelete={this.clear}
                                selectEnabled={false}
                                maxSelectItems={0}
                                clickableThumbnail={false}
                            />
                            }
                        </div>
                    </div>
                )}
                {touched && error && <div className={classNamesPrefixed({'input-below-error': true})}>{error}</div>}
                <MediaSelectModal
                    show={modal}
                    maxSelectItems={1}
                    onInsert={(name, itemsToInsert) => this.insertImage(name, itemsToInsert)}
                    onClose={() => this.hideModal()}
                    filterMediaTypeEnabled={false}
                    defaultMediaType="images"
                />
            </React.Fragment>
        );

        return (
            <Fragment>
                {omitCollapsible ? (
                    <div>{content}</div>
                ) : (
                    <Collapsible
                        {...collapsibleSettings}
                        trigger={label ?
                            <label className={classNamesPrefixed({"trigger__label": true})}>{label}</label> : ''}
                        open={expanded}
                    >
                        {content}
                    </Collapsible>
                )}
            </Fragment>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        loadedMediaItem: state.media.item
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        single: (id) => dispatch(single(id))
    };
};

ImageField = connect(mapStateToProps, mapDispatchToProps)(ImageField);

export default ImageField;


// WEBPACK FOOTER //
// ./src/core/admin/components/Fields/ImageField.js